import { Injectable } from '@angular/core';

import { ThumbnailService } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkThumbnailService {
  constructor(private readonly thumbnailService: ThumbnailService) {}

  getMimeTypeIcon(mimeType: string): string {
    return this.thumbnailService.getMimeTypeIcon(mimeType);
  }
}
